import { NgModule } from '@angular/core';
import { ErzeugungsanlagePageComponent } from './erzeugungsanlage-page/erzeugungsanlage-page.component';
import { RouterModule, Routes } from '@angular/router';
import { ErzeugungsanlageDetailComponent } from './erzeugungsanlage-detail/erzeugungsanlage-detail.component';

export const erzeugungsanlageRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Erzeugungsanlagen
        path: 'list',
        component: ErzeugungsanlagePageComponent,
    },
    {   // lists all Erzeugungsanlage that belong to a particular Netzbetreiber/Stadtwerk
        path: 'list/:stadtwerkeId',
        component: ErzeugungsanlagePageComponent,
    },
    {   // shows the details of an Erzeugungsanlage
        path: 'detail/:stadtwerkeId/:westnetzId',
        component: ErzeugungsanlageDetailComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(erzeugungsanlageRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class ErzeugungsanlageRoutingModule {
}
